import { Heading, Link } from '@primer/react';
import ComponentLayout from '~/src/layouts/component-layout';
import * as React from 'react';
export default {
  Heading,
  Link,
  ComponentLayout,
  React
};